import { render, staticRenderFns } from "./SellerDisclosureStatement.vue?vue&type=template&id=59dd6054&scoped=true&"
import script from "./SellerDisclosureStatement.vue?vue&type=script&lang=js&"
export * from "./SellerDisclosureStatement.vue?vue&type=script&lang=js&"
import style0 from "./SellerDisclosureStatement.vue?vue&type=style&index=0&id=59dd6054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dd6054",
  null
  
)

export default component.exports